import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query';

interface UseReportsSubmit {
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useReportSubmit = ({ onSuccess, onError }: UseReportsSubmit) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['reportSubmit'],
    mutationFn: async ({
      filters,
      report_type,
    }: {
      filters: { [key: string]: any; },
      report_type: string;
    }) => {
      const payload = {
        ...filters,
        q: {
          ...filters?.q,
          city_id_eq: filters?.q?.city_id_eq ? filters?.q?.city_id_eq?.value : undefined,
          product_id_eq: filters?.q?.product_id_eq ? filters?.q?.product_id_eq?.value : undefined,
        },
        report_type,
      };

      await privateAxios.post(`/reports/entries/submit`, payload);
    },
    onSuccess,
    onError,
  });
};
